import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import EvrNumberUpdate from "../EvrNumberUpdate/EvrNumberUpdate";

const EvrNumberConfigurator = () => {
  const [EvrCount, setEvrCount] = useState(0);

  const title = "Evr Number Configurator";

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "Evr Number",
            title: "Evr Number",
            count: EvrCount,
            countColor: 'blue',
            backgroundColor:'blue',
            component: EvrNumberUpdate,
            props: {
              handleCountChange: setEvrCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default EvrNumberConfigurator;
